import React from "react"
import { connect } from "react-redux"
import { compose } from "redux"
import PropTypes from "prop-types"
import styled, { ThemeProvider } from "styled-components"
import MobileNavItem from "./MobileNavItem"
import BackToTalentToolboxLink from "./BackToTalentToolboxLink"

const Nav = styled.nav`
  background: ${prop => prop.theme.navBackgroundColor};
  width: 100vw;
  height: 100vh;
`

const Container = styled.div`
  padding: 20px;
`

const NavList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 40px 0 0 0;
  text-align: center;
`

const CloseIcon = styled.i`
  position: absolute;
  top: 0;
  right: 0;
  color: #fff;
  cursor: pointer;
  padding: 10px;
  font-size: 26px;
`

const BackToTtLink = styled(BackToTalentToolboxLink)`
  color: #ffffff !important;
  border-top: solid 1px #fff;
  margin-top: 20px;
  padding-top: 20px;
  display: block;
`

function MobileNav({ navItems, onToggleMobileNav, theme }) {
  const navLinkClassNames = "nav-link nav-toggler waves-effect waves-dark"

  const navLinks = navItems.map((navItem) => {
    return (
      <MobileNavItem
        key={navItem.route}
        route={navItem.route}
        text={navItem.name}
        linkClassNames={navLinkClassNames}
        clickHandler={onToggleMobileNav}
      />
    )
  })

  return (
    <ThemeProvider theme={theme}>
      <Nav>
        <CloseIcon onClick={onToggleMobileNav} className="mdi mdi-close" />
        <Container>
          <NavList>
            {navLinks}
            <li className="nav-item">
              <BackToTtLink extraClassNames={navLinkClassNames} />
            </li>
          </NavList>
        </Container>
      </Nav>
    </ThemeProvider>
  )
}

MobileNav.propTypes = {
  navItems: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    route: PropTypes.string.isRequired,
  })).isRequired,
  onToggleMobileNav: PropTypes.func.isRequired,
  theme: PropTypes.shape({
    primaryColor: PropTypes.string.isRequired,
    primaryColorHover: PropTypes.string.isRequired,
    navBackgroundColor: PropTypes.string.isRequired,
  }).isRequired,
}

function mapStateToProps(state) {
  return {
    theme: state.userDetail.theme,
  }
}

export default compose(connect(mapStateToProps))(MobileNav)



// WEBPACK FOOTER //
// ./src/components/layout/navigation/MobileNav.jsx